/* tslint:disable */
import { GenProvider } from './../../../providers/gen/gen';
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
// Import navigation elements
import { navigation } from './../../_nav';

import { Router } from '@angular/router';


@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="nav">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)&&isShow(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>
    `
})
export class AppSidebarNavComponent implements OnInit {
  public nav : any;
  public navigation : any;
  permissao: any;

  constructor(public genProvider: GenProvider) {
    this.navigation = navigation;
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.isMenu();
    }, 1000);
  }

  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }
  public isShow(item) {
   return item.show ? true : false
  }
  public isMenu(){
    let parametro = this.genProvider.parametros;
 //   console.log(parametro)
    try {
      this.genProvider.onGetFilterOrder('login_permissao','nome', 'key_login',parametro.key_login)
      .subscribe(data => {
        this.nav = [];
           this.permissao = JSON.parse(JSON.stringify(data))
      //     console.log (this.permissao, this.navigation)
           for (let index = 0; index < this.navigation.length; index++) {
            if (!this.isDivider(this.navigation[index]) && !this.isTitle(this.navigation[index])){
              let res = this.permissao.filter(obj => {
                return obj.nome == this.navigation[index].name
              });
             if (res.length > 0) {
               this.navigation[index].show = !res[0].per_bloqueio
               let child :any
               try {
                  child = this.navigation[index].children || false
               } catch (error) {
                 child = false;
                 console.log(error)
               }
               if (child){
                 for (let i = 0; i < this.navigation[index].children.length; i++) {
                   let res = this.permissao.filter(obj => {
                      return obj.nome == this.navigation[index].children[i].name
                    });
                    if (res.length > 0) {
                    this.navigation[index].children[i].show = !res[0].per_bloqueio
                    } else {
                     if (parametro.nivel=="99"){
                       this.navigation[index].children[i].show = true
                     } else {
                       this.navigation[index].children[i].show = false
                     }
                    }
                  }
               }

             }else {
               if (parametro.nivel=="99"){
                 this.navigation[index].show = true
                 let child :any
                 try {
                    child = this.navigation[index].children || false
                 } catch (error) {
                   child = false;
                   console.log(error)
                 }
                 if (child){
                  for (let i = 0; i < this.navigation[index].children.length; i++) {
                      if (parametro.nivel=="99"){
                        this.navigation[index].children[i].show = true
                      } else {
                        this.navigation[index].children[i].show = false
                      }
                   }
                }
               } else {
                 this.navigation[index].show = false
               }
             }
            }
          }
           this.nav = this.navigation;
       },
       err =>{
        console.log(err)
      }
     );
    } catch (error) {
      if (parametro.nivel=="99"){
        this.nav = this.navigation;
      }
    }

  }
}

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor( private router: Router )  { }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="!isExternalLink(); else external"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]"
      (click)="hideMobile(link.name)">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      <p-progressSpinner *ngIf="spinner" strokeWidth="8" [style]="{width: '15px', height: '15px'}" ></p-progressSpinner>
    </a>
    <ng-template #external>
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        <p-progressSpinner *ngIf="spinner" [style]="{width: '25px', height: '25px'}" ></p-progressSpinner>
        <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
        {{ link.name }}
        <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
      </a>
    </ng-template>
    <!-- p-progressBar *ngIf="spinner" mode="indeterminate" [style]="{'height': '6px', 'background-color': black}"></p-progressBar -->

    `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;
  spinner: boolean;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }
  public isShow() {
    return this.link.show ? true : false
   }
  public hideMobile(name) {
    this.genProvider.frmActive = name;
   // this.router.navigate(['/spinner']);
   this.spinner=!this.spinner;
   setTimeout(() => {
    this.spinner=!this.spinner;
   }, 1000);

    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }

  constructor( public genProvider: GenProvider, private router: Router) { }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
  <ng-template [ngIf]="isShow(link)">
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <ng-template [ngIf]="isShow(child)">
          <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
        </ng-template>
      </ng-template>
    </ul>
  </ng-template>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isShow(item) {
    return item.show ? true : false
   }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() { }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts